import { t } from '@framework/i18n';
import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { ValueRangeRuleComponent } from './ValueRangeRuleComponent';

const configValidator = yup
  .object({
    min: yup.number().notRequired().label('Minimo'),
    max: yup.number().notRequired().greaterThan('min').label('Massimo'),
    minCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
    maxCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown()
  .nullable();

type IRuleValueRangeType = yup.InferType<typeof configValidator>;

export const ValueRangeRule: IRuleType<IRuleValueRangeType> = {
  type: RuleType.ValueRange,
  name: 'Valore massimo',
  configComponent: ValueRangeRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule) return schema;
    const { min, max } = rule;

    if (min != null) {
      schema = schema.test({
        name: 'min-value',
        params: { min: rule.min },
        skipAbsent: true,
        message: rule.minCustomMessage
          ? rule.minCustomMessage
          : t(
              'rules.value-range.min',
              'Il campo ${label} deve essere maggiore o uguale a {{min}}',
              { min },
            ),
        test: function (value) {
          // Ci pensa la regola required a controllare l'esistenza del valore
          if (value == null) return true;
          return value >= min;
        },
      });
    }

    if (max != null) {
      schema = schema.test({
        name: 'max-value',
        params: { max: rule.max },
        skipAbsent: true,
        message: rule.maxCustomMessage
          ? rule.maxCustomMessage
          : t(
              'rules.value-range.max',
              'Il campo ${label} deve essere minore o uguale a {{max}}',
              { max },
            ),
        test: function (value) {
          // Ci pensa la regola required a controllare l'esistenza del valore
          if (value == null) return true;
          return value <= max;
        },
      });
    }

    return schema;
  },
};
